import { Modal, ModalProps } from "layouts"
import useTwoFactorAuth from "pages/Verify/TwoFactorAuth/useTwoFactorAuth"
import TwoFactorAuthModal from "pages/Verify/TwoFactorAuth/Setup/TwoFactorAuthModal"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { clearOperation } from "redux/slices/graphql_2FA_RequiredOperationSlice"

// ================
// Modal Verify 2FA
// ================
interface ModalVerifyTwoFactorAuthProps {
   activeModal: string | false
   onClose: () => void
}
const ModalVerifyTwoFactorAuth: React.FC<ModalVerifyTwoFactorAuthProps> = ({
   activeModal,
   onClose,
}) => {
   const {
      verifyTwoFactorAuth,
      error: { verifyTwoFactorAuthError, resendTwoFactorAuthCodeError },
      loading: { verifyTwoFactorAuthLoading, resendTwoFactorAuthCodeLoading },
      verifyOperationStatus,
      resendTwoFactorAuthCode,
      attemptCount,
      twoFactorAuthMethod,
      setTwoFactorAuthMethod,
      settings,
   } = useTwoFactorAuth()

   // Data Props
   const twoFactorAuthModalProps = {
      verifyTwoFactorAuth,
      verifyTwoFactorAuthError,
      verifyTwoFactorAuthLoading,
      resendTwoFactorAuthCode,
      resendTwoFactorAuthCodeError,
      resendTwoFactorAuthCodeLoading,
      twoFactorAuthMethod,
      settings,
      setTwoFactorAuthMethod,
      attemptCount,
      onClose,
   }

   // dispatch clearOperationStatus when the modal is closed
   const dispatch = useDispatch()
   const clearOperationFromReduxStore = () => dispatch(clearOperation())

   const handleCloseModal = () => {
      clearOperationFromReduxStore()
      onClose()
   }

   // Modal Props
   const modalProps: ModalProps = {
      visible: activeModal === "twoFactorAuth",
      onClose: handleCloseModal,
      fullscreenOnMobile: true,
      renderComponent: {
         show: true,
         component: () => <TwoFactorAuthModal {...twoFactorAuthModalProps} />,
      },
   }

   // Close the modal if the user successfully verified the 2FA
   useEffect(() => {
      verifyOperationStatus && onClose()
   }, [verifyOperationStatus])

   // ===
   // JSX
   // ===
   return <Modal {...modalProps} />
}

export default ModalVerifyTwoFactorAuth
